<template>
  <div class="taskDispatchDetail">
    <el-container>
      <el-header>
        <div class="header">
          <div class="header-left">
            <el-button type="primary" @click="addJob">新增作业</el-button>
          </div>
          <div class="header-right">
            <el-link
              v-if="hasDelayRecord"
              type="danger"
              icon="el-icon-s-help"
              @click="showChangeRecord()"
              >已延期</el-link
            >
            <el-link
              v-if="hasTransferRecord"
              type="danger"
              icon="el-icon-s-help"
              @click="showChangeRecord()"
              >已转单</el-link
            >
          </div>
        </div>
      </el-header>
      <el-main v-if="JSON.stringify(workInfo) === '{}'">尚无提交作业</el-main>
      <el-main v-else>
        <div class="flex-row" style="height: calc(100% - 60px)">
          <div class="left">
            <div
              v-for="(item, index) in workInfoList"
              :key="index"
              class="time"
              @click="chooseDate(index)"
              :class="{ timeChoose: selectWorkItemId == item.id }"
            >
              {{ item.workDate }}
            </div>
          </div>
          <div class="middle">
            <div class="address">
              <div style="display: inline-block; margin-right: 20px">
                # {{ detail.busTask.workName }}
              </div>
              <!--          <img-->
              <!--            style="width: 20px; height: 20px"-->
              <!--            src="@/assets/teamGroup/location_icon.png"-->
              <!--            alt=""-->
              <!--          />-->
            </div>
            <div>
              <div class="title">现场情况描述：</div>
              <div>{{ workInfo.description }}</div>
              <div
                style="padding: 20px 0; flex-wrap: wrap"
                class="flex-row align-center"
              >
                <el-image
                  style="width: 160px; height: 120px"
                  v-for="(item, index) in workInfo.photoList"
                  :key="index"
                  :src="item"
                  :preview-src-list="[item]"
                ></el-image>
                <!-- <ImageZ
                style="margin-right: 10px;margin-top: 10px;"
                v-for="item in workInfo.photoList" 
                width="200px"
                height="150px"
                :showDetele="true"
                :src="item"
                :key="item" ></ImageZ> -->
                <!-- <el-image style="width: 200px; height: auto; margin-right: 10px"
                  v-for="(item, index) in workInfo.photoList" :key="index" :src="item" alt=""
                  :preview-src-list="workInfo.photoList" /> -->
              </div>
            </div>

            <div>
              <div class="title">现场视频：</div>
              <div
                v-if="
                  workInfo.jlyList == undefined || workInfo.jlyList.length <= 0
                "
                style="height: auto; padding: 20px 20px"
              >
                暂无视频
              </div>
              <div v-else style="height: auto; padding: 20px 0">
                <div v-for="(item, index) in workInfo.jlyList" :key="index">
                  <video
                    style="width: 200px; height: auto; margin-right: 10px"
                    v-if="item.length > 0"
                    :src="item"
                    alt=""
                    controls="controls"
                  ></video>
                </div>
              </div>
            </div>

            <div>
              <div class="title">关键节点：</div>
              <div
                style="
                  display: inline-block;
                  flex-direction: row;
                  position: relative;
                  width: auto;
                "
              >
                <div
                  style="
                    position: absolute;
                    width: 100%;
                    height: 1px;
                    border-top: 1px dashed #ccc;
                    left: 0;
                    top: 65px;
                    z-index: 1;
                  "
                ></div>
                <div
                  style="
                    display: inline-block;
                    position: relative;
                    z-index: 999;
                  "
                >
                  <div class="checkItem" v-if="workInfo.checkInTime">
                    <div class="type">作业签到</div>
                    <div
                      style="
                        width: 15px;
                        height: 10px;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                        background-color: white;
                      "
                    ></div>
                    <div>{{ workInfo.checkInAddress }}</div>
                    <div>{{ workInfo.checkInTime }}</div>
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="workInfo.checkInUrl"
                      :preview-src-list="[workInfo.checkInUrl]"
                    ></el-image>
                  </div>
                </div>
                <div
                  style="
                    display: inline-block;
                    position: relative;
                    z-index: 999;
                  "
                >
                  <div class="checkItem" v-if="workInfo.checkOutTime">
                    <div class="type">作业签退</div>
                    <div
                      style="
                        width: 15px;
                        height: 10px;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                        background-color: white;
                      "
                    ></div>
                    <div>{{ workInfo.checkOutAddress }}</div>
                    <div>{{ workInfo.checkOutTime }}</div>
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="workInfo.checkOutUrl"
                      :preview-src-list="[workInfo.checkOutUrl]"
                    ></el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="rightTop">
              <div class="car">
                <div
                  class="carItem"
                  v-for="(item, index) in detail.busTaskCars"
                  :key="index"
                >
                  <div class="carIcon">
                    <img src="@/assets/teamGroup/car_icon.png" alt="" />
                  </div>
                  <div class="carName">{{ item.carNum }}</div>
                  <div class="carInfo">
                    <div class="tips warining" v-if="item.carMark === 0">
                      固
                    </div>
                    <div class="tips primary" v-else-if="item.carMark === 1">
                      流
                    </div>
                    <div class="tips success" v-if="item.insuranceMark === 1">
                      保
                    </div>
                  </div>
                  <div class="carRoad" @click="goToCarPath(item)">[轨迹]</div>
                </div>
              </div>
              <div class="manager">
                <div class="managerIcon">
                  <img
                    style="width: 30px; height: 30px"
                    src="@/assets/teamGroup/manager_icon.png"
                    alt=""
                  />
                </div>
                <div class="managerName">
                  {{ detail.busTask.groupManageName }}
                </div>
              </div>
            </div>
            <div>
              <div
                style="
                  font-size: 16px;
                  font-weight: 600;
                  height: 20px;
                  line-height: 20px;
                  margin-top: 20px;
                "
              >
                工作量计算
              </div>
              <div
                v-for="(item, index) in filteredTaskItemQuantities"
                :key="'quantity' + index"
                style="border-bottom: 1px solid #ccc"
              >
                <div class="workItem">
                  <div class="workName">
                    {{ item.workItemName }}
                  </div>
                  <div class="workQuantity">
                    {{ item.quantity }}({{ item.workItemUnitName }})
                  </div>
                </div>
                <div style="padding-bottom: 5px">备注:{{ item.remark }}</div>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer>
        <div style="padding-top: 20px">
          <el-button type="primary" @click="backPage()">返回</el-button>

          <el-button
            v-if="detail.busTask && detail.busTask.status === 2"
            type="danger"
            @click="yanshou"
          >
            立即验收
          </el-button>
        </div>
      </el-footer>
    </el-container>
    <el-dialog
      @closed="closeDialog"
      :destroy-on-close="true"
      title="今日作业项"
      :lock-scroll="false"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div class="dialog-body">
        <el-form
          :rules="rules"
          ref="form"
          :model="fromData"
          label-width="110px"
        >
          <el-form-item label="工人签到" prop="checkInTime">
            <div class="align-center">
              <el-date-picker
                v-model="fromData.checkInTime"
                type="datetime"
                :picker-options="pickerOptionsInTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择签到日期时间"
              >
              </el-date-picker>
              <!-- <ImageZ v-if="imageOne" @deleteFile="deleteFileOne" style="margin-right: 10px" :src="imageOne"></ImageZ>
              <uploadFile v-else @imageDataHandle="imageDataHandle"></uploadFile> -->
            </div>
          </el-form-item>
          <el-form-item label="现场情况描述" prop="description">
            <div class="flex-col">
              <el-input
                placeholder="请输入现场情况描述"
                v-model="fromData.description"
              ></el-input>
              <div class="align-center" style="flex-wrap: wrap">
                <ImageZ
                  @deleteFile="deleteFile(index)"
                  style="margin-right: 10px; margin-top: 10px"
                  v-for="(item, index) in imageTwo"
                  :key="index"
                  :src="item.fileUrl"
                ></ImageZ>
                <uploadFile
                  style="margin-top: 10px"
                  accept="image/*,video/*"
                  @imageDataHandle="imageDataHandleTwo"
                >
                </uploadFile>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="工作量计算" prop="itemQuantitys">
            <div class="flex-col">
              <div
                class="align-center"
                v-for="(item, index) in fromData.itemQuantitys"
                :key="index"
                style="margin-bottom: 10px"
              >
                <el-select
                  style="margin-right: 10px"
                  v-model="item.workItemId"
                  placeholder="请选择"
                  @change="changeWorkList($event, index)"
                >
                  <el-option
                    v-for="item in workItemOptions"
                    :key="item.id"
                    :label="item.allName"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-input
                  style="margin-right: 10px; width: 250px"
                  v-model="item.remark"
                  placeholder="备注"
                ></el-input>
                <el-input
                  v-model="item.quantity"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  placeholder="请输入工程量"
                ></el-input>
                <li
                  v-show="fromData.itemQuantitys.length > 1"
                  @click="deleteWorkList(index)"
                  class="el-icon-remove deleteicon"
                ></li>
              </div>
            </div>
            <el-button type="primary" @click="addWorkList">
              添加项目内容
            </el-button>
          </el-form-item>
          <el-form-item label="工人签退" prop="checkOutTime">
            <div class="align-center">
              <el-date-picker
                v-model="fromData.checkOutTime"
                type="datetime"
                :picker-options="pickerOptionsOutTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择签退日期时间"
              >
              </el-date-picker>
              <!-- <ImageZ v-if="imageThree" @deleteFile="deleteFileThree" style="margin-right: 10px" :src="imageThree">
              </ImageZ>
              <uploadFile v-else @validity="validity" @imageDataHandle="imageDataHandleThree"></uploadFile> -->
            </div>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <!-- <el-button @click="save">暂存</el-button> -->
        <el-button type="primary" @click="submit"> 完成今日作业项 </el-button>
      </template>
    </el-dialog>

    <!-- 变更记录弹窗 -->
    <el-dialog
      :title="changeDialogTitle"
      :visible.sync="changeRecordVisible"
      width="60%"
      :destroy-on-close="true"
    >
      <div class="change-record-container">
        <el-card
          v-for="(record, index) in changeRecords"
          :key="index"
          class="change-record-card"
          shadow="hover"
        >
          <div class="record-header">
            <span class="record-label">变更人：</span>
            <span class="record-value">{{ record.createName }}</span>
            <span class="record-divider">|</span>
            <span class="record-label">变更时间：</span>
            <span class="record-value">{{ record.createTime }}</span>
          </div>
          <div class="record-content">
            <div class="record-title">变更记录：</div>
            <div v-if="getFieldName(item.fieldName)">
              <div
                v-for="(item, idx) in record.changeLog"
                :key="idx"
                class="record-item"
              >
                {{ getFieldName(item.fieldName) }}：{{
                  formatTime(item.oldValue)
                }}
                => {{ formatTime(item.newValue) }}
              </div>
            </div>

            <div>车辆变更至：</div>
            <div
              v-if="
                record.taskCarChangeRecords &&
                record.taskCarChangeRecords.length > 0
              "
            >
              <div
                v-for="(carItem, carIndex) in record.taskCarChangeRecords"
                :key="'car' + carIndex"
                class="record-item"
              >
                {{ carItem.carNum }}
              </div>
            </div>
            <div v-else class="record-item" style="color: #909399">
              无车辆变更记录
            </div>
          </div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TaskDispatchApi from "@/api/taskDispatch";
import uploadFile from "./components/uploadFile.vue";
import ImageZ from "./components/image.vue";
import ProjectApplyApi from "@/api/projectApply";
import { cloneDeep } from "lodash-es";
export default {
  name: "TaskDispatchDetail",
  data() {
    const validateDesc = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入现场情况描述"));
      } else {
        callback();
      }
    };
    const validateQuantity = (rule, value, callback) => {
      if (value.length <= 0) {
        callback(new Error("请选择工作量"));
      } else {
        const item = value.some((el) => !el.quantity || !el.workItemId);
        // console.log(item,'item');
        if (item) {
          callback(new Error("请填写完整工作量信息"));
        } else {
          callback();
        }
      }
    };
    return {
      rules: {
        checkInTime: [
          {
            required: true,
            message: "请选择签到日期时间",
            trigger: ["blur", "change"],
          },
        ],
        checkOutTime: [
          {
            required: true,
            message: "请选择签退日期时间",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          { required: true, validator: validateDesc, trigger: "blur" },
        ],
        itemQuantitys: [
          {
            type: "array",
            required: true,
            validator: validateQuantity,
            trigger: ["blur", "change"],
          },
        ],
      },
      detail: {
        busTask: {},
        busTaskItemQuantities: [],
      },
      workInfo: {},
      workInfoList: [],
      workName: "",
      selectDate: "",
      selectWorkItemId: "",
      dialogVisible: false,
      fromData: {
        cameraId: "",
        cameraUrl: "",
        checkInTime: "",
        checkInUrl: "",
        checkOutTime: "",
        checkOutUrl: "",
        description: "",
        id: "",
        itemQuantitys: [
          {
            taskId: "",
            quantity: "",
            taskItemId: "",
            workItemId: "",
            workItemName: "",
            workItemUnitName: "",
          },
        ],
        photoUrl: "",
        projectId: "",
        status: "",
        taskId: "",
        workDate: "",
      },
      workItemOptions: [],
      imageOne: "",
      imageTwo: [],
      imageThree: "",
      submitData: {
        createTime: "",
        current: 1,
        groupManageId: "",
        size: 1,
        status: 1,
        taskId: "",
        taskItemAddDto: {},
        taskItemId: "",
      },
      // 变更记录相关数据
      changeRecordVisible: false,
      changeDialogTitle: "",
      changeRecords: [],
    };
  },
  watch: {
    "$route.query": {
      handler({ id, pid }) {
        this.fromData.taskId = id || "";
        this.fromData.projectId = pid || "";
        this.submitData.taskId = id || "";
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    uploadFile,
    ImageZ,
  },
  computed: {
    // 判断是否存在延期记录
    hasDelayRecord() {
      return this.changeRecords.some(
        (record) => record.changeType === 0 || record.changeType === 2
      );
    },
    // 判断是否存在转单记录
    hasTransferRecord() {
      return this.changeRecords.some(
        (record) => record.changeType === 1 || record.changeType === 2
      );
    },
    pickerOptionsOutTime() {
      return {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.fromData.checkInTime).getTime();
        },
      };
    },
    pickerOptionsInTime() {
      return {
        disabledDate: (time) => {
          if (this.fromData.checkOutTime) {
            return (
              time.getTime() > new Date(this.fromData.checkOutTime).getTime()
            );
          } else {
            return false;
          }
        },
      };
    },
    // 根据选择的日期过滤工程量
    filteredTaskItemQuantities() {
      if (!this.selectWorkItemId || !this.detail.busTaskItemQuantities) {
        return [];
      }
      // 过滤出与当前选择的workItemId匹配的工程量
      return this.detail.busTaskItemQuantities.filter(
        (item) => item.taskItemId === this.selectWorkItemId
      );
    },
  },
  created() {
    // console.log('projectId',this.$route.query.pid);
    this.getAllWorkLit();
    this.getDetail();
    // 页面加载时获取变更记录
    this.getChangeRecords();
  },
  methods: {
    // 字段名映射
    getFieldName(field) {
      const fieldMap = {
        groupId: null, // 不显示 groupId 字段
        groupManageId: null, // 不显示 groupManageId 字段
        groupName: "班组",
        groupManageName: "班组长",
        startTime: "开始时间",
        endTime: "结束时间",
        time: "时间",
      };
      return fieldMap[field] || null;
    },
    // 格式化时间
    formatTime(value) {
      // 检查是否为时间戳（数字类型且大于10000）
      if (typeof value === "number" && value > 10000) {
        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      return value;
    },
    closeDialog() {
      this.fromData = this.$options.data().fromData;
      this.submitData = this.$options.data().submitData;
      this.imageOne = "";
      this.imageTwo = [];
      this.imageThree = "";
    },
    validity() {
      return !!this.fromData.checkInUrl;
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.fromData.status = 1;
          this.fromData.photoUrl = this.imageTwo
            .map((el) => el.filePath)
            .join(",");
          this.fromData.itemQuantitys = this.fromData.itemQuantitys.map(
            (el) => {
              return {
                ...el,
                taskId: this.$route.query.id,
              };
            }
          );
          this.submitData.taskItemAddDto = this.fromData;
          TaskDispatchApi.uploadTaskItem(this.submitData).then(({ data }) => {
            if (data.code === 200) {
              this.dialogVisible = false;
              this.closeDialog();
              this.getDetail();
              this.$message.success("保存成功");
            }
          });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    save(status) {
      const params = cloneDeep(this.fromData);
      //签退携带签到id
      if (status === 3) {
        params.id = this.submitData.taskItemId;
      }
      params.status = status;
      params.photoUrl = this.imageTwo.map((el) => el.filePath).join(",");
      if (status !== 2 && status !== 3) {
        params.itemQuantitys = params.itemQuantitys.map((el) => {
          return {
            ...el,
            taskId: this.$route.query.id,
          };
        });
      } else {
        params.itemQuantitys = [];
      }
      TaskDispatchApi.addTaskItem(params).then(({ data }) => {
        if (data.code === 200) {
          this.submitData.taskItemId = data.data.id;
          const types = {
            0: "暂存",
            1: "已提交",
            2: "签到",
            3: "签退",
          };
          this.$message.success(`${types[status]}成功`);
        }
      });
    },
    deleteFileOne() {
      this.imageOne = "";
      this.fromData.checkInUrl = "";
    },
    deleteFileThree() {
      this.imageThree = "";
      this.fromData.checkOutUrl = "";
    },
    deleteFile(index) {
      this.imageTwo.splice(index, 1);
    },
    deleteWorkList(index) {
      this.fromData.itemQuantitys.splice(index, 1);
    },
    addWorkList() {
      this.$set(
        this.fromData.itemQuantitys,
        this.fromData.itemQuantitys.length,
        {
          taskId: "",
          quantity: "",
          taskItemId: "",
          workItemId: "",
          workItemName: "",
          workItemUnitName: "",
        }
      );
    },
    getAllWorkLit() {
      ProjectApplyApi.queryAllWorkItemByProjectId({
        id: this.$route.query.pid,
      }).then((res) => {
        if (res.data.code === 200) {
          console.log(res.data.data);

          this.workItemOptions = res.data.data.map((item) => {
            item.allName = item.workName + "-" + item.itemName;
            return item;
          });
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    changeWorkList(value, index) {
      this.workItemOptions.forEach((item) => {
        if (value === item.id) {
          this.fromData.itemQuantitys[index].workItemId = item.id;
          this.fromData.itemQuantitys[index].workItemName = item.itemName;
          this.fromData.itemQuantitys[index].workItemUnitName =
            item.itemUnitName;
        }
      });
    },
    imageDataHandle(imgData) {
      this.imageOne = imgData.fileUrl;
      this.fromData.checkInUrl = imgData.filePath;
      //签到
      this.save(2);
    },
    imageDataHandleThree(imgData) {
      this.imageThree = imgData.fileUrl;
      this.fromData.checkOutUrl = imgData.filePath;
      //签退
      this.save(3);
    },
    imageDataHandleTwo(imgData) {
      this.imageTwo.push(imgData);
    },
    addJob() {
      this.dialogVisible = true;
    },
    yanshou() {
      this.$confirm("确认验收此任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          TaskDispatchApi.checkTask({
            projectId: this.$route.query.pid,
            taskId: this.$route.query.id,
            current: 0,
            size: 0,
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: "success",
                message: "验收成功!",
              });
              this.detail.busTask.status = 3;
            }
          });
        })
        .catch(() => {});
    },
    chooseDate(index) {
      this.workInfo = this.workInfoList[index];
      this.selectDate = this.workInfo.workDate;
      this.selectWorkItemId = this.workInfo.id;
      (this.workInfo.photoList = this.workInfo.photoUrl.split(",")),
        console.log(this.workInfo.photoUrl.split(","));

      this.workInfo.jlyList = this.workInfo.cameraUrl
        ? this.workInfo.cameraUrl.split(",")
        : [];
    },
    getDetail() {
      TaskDispatchApi.getTaskDetail({
        current: 1,
        size: 10,
        taskId: this.$route.query.id,
        projectId: this.$route.query.pid,
      }).then((res) => {
        this.detail = res.data.data;
        console.log("任务详情:", this.detail);
        console.log("所有作业数据(busTaskItems):", this.detail.busTaskItems);
        this.workInfoList = this.detail.busTaskItems;
        if (this.workInfoList && this.workInfoList.length > 0) {
          this.selectDate = this.workInfoList[0].workDate;
          this.workInfo = this.workInfoList[0];
          console.log("当前选中作业(workInfo):", this.workInfo);
          console.log("图片URL(photoUrl):", this.workInfo.photoUrl);
          console.log(
            "图片列表(photoList):",
            this.workInfo.photoUrl.split(",")
          );
          (this.workInfo.photoList = this.workInfo.photoUrl.split(",")),
            (this.workInfo.jlyList = this.workInfo.cameraUrl
              ? this.workInfo.cameraUrl.split(",")
              : []);
        }
      });
    },
    goToCarPath(car) {
      this.$router.push(
        "/carLocation?no=" + car.carNum + "&date=" + this.selectDate + "&type=1"
      );
    },
    backPage() {
      this.$router.back();
    },
    // 获取变更记录数据
    getChangeRecords() {
      // 调用API获取变更记录数据
      TaskDispatchApi.getChangeRecord({
        taskId: this.$route.query.id,
        projectId: this.$route.query.pid,
        current: 1,
        size: 10,
      })
        .then((res) => {
          if (res.data.code === 200) {
            console.log(res.data.data);

            // 将 changeLog 字段从 JSON 字符串解析为数组
            this.changeRecords = (res.data.data || []).map((record) => {
              return {
                ...record,
                changeLog:
                  typeof record.changeLog === "string"
                    ? JSON.parse(record.changeLog)
                    : record.changeLog,
              };
            });
          } else {
            this.$message({
              message: res.data.message || "获取变更记录失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error("获取变更记录失败:", err);
          this.$message({
            message: "获取变更记录失败",
            type: "error",
          });
        });
    },
    // 显示变更记录弹窗
    showChangeRecord() {
      this.changeRecordVisible = true;
      this.changeDialogTitle = "延期/转单变更记录";
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.deleteicon {
  margin-left: 20px;
  font-size: 20px;
  color: red;
  padding-top: 10px;
  cursor: pointer;
}

.line {
  width: 100%;
  height: 30px;
  border-bottom: solid 1px #ccc;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.status {
  margin-left: 10px;
  margin-right: 5px;
  background-color: #67c23a;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.el-header {
  display: flex;
  align-items: center;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .header-left {
    display: flex;
    align-items: center;
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.taskDispatchDetail {
  padding: 20px;
  min-width: auto;
  overflow: hidden;
  overflow-y: auto;

  .left {
    width: 100px;
    border-right: 1px solid #ccc;
    flex-shrink: 0;

    .time {
      height: 50px;
      line-height: 50px;
      text-align: right;
      padding-right: 10px;
      color: black;
    }

    .time:hover {
      background-color: #409eff;
      color: white;
    }

    .timeChoose {
      background-color: #409eff;
      color: white;
    }
  }

  .middle {
    padding: 0 20px;
    flex: 1;

    .address {
      float: right;
      display: flex;
      flex-direction: row;
    }

    .title {
      font-weight: 600;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
    }
  }

  .right {
    width: 360px;
    border-left: 1px solid #ccc;
    padding-left: 10px;
    flex-shrink: 0;

    .rightTop {
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #ccc;
      padding-bottom: 20px;
      align-items: center;

      .car {
        border-right: 1px solid #ccc;

        .carItem {
          display: flex;
          flex-direction: row;
          margin-right: 20px;
          padding: 10px 0;
          align-items: center;

          .carIcon {
            width: 30px;
            height: 30px;

            img {
              width: 30px;
              height: 30px;
            }
          }

          .carName {
            height: 20px;
            line-height: 20px;
            margin-left: 10px;
          }

          .carInfo {
            width: auto;
            height: 20px;
            margin-left: 10px;

            .tips {
              height: 20px;
              width: 20px;
              line-height: 20px;
              text-align: center;
              color: white;
              background-color: #e6a23c;
              border-radius: 2px;
              display: inline-block;
              margin-right: 2px;
            }

            .success {
              background-color: #67c23a;
            }

            .waring {
              background-color: #e6a23c;
            }

            .danger {
              background-color: #f56c6c;
            }

            .primary {
              background-color: #409eff;
            }
          }

          .carRoad {
            height: 20px;
            width: 50px;
            line-height: 20px;
            margin-left: 10px;
            color: red;
            cursor: pointer;
          }
        }
      }

      .manager {
        display: flex;
        flex-direction: row;
        align-items: center;

        .managerIcon {
          width: 30px;
          height: 30px;
          margin-left: 10px;
        }

        .managerName {
          margin-left: 10px;
        }
      }
    }

    .workItem {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 40px;
      line-height: 40px;

      .workName {
        flex: 5;
      }

      .workQuantity {
        flex: 1;
        text-align: right;
      }
    }
  }

  .checkItem {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #ccc;
    border-radius: 10px;
    margin: 20px;
    padding: 10px 20px;
    width: 200px;

    div {
      height: 30px;
      line-height: 30px;
    }

    img {
      width: 100px;
      height: 100px;
    }

    .type {
      font-weight: 600;
    }
  }
}

// 变更记录弹窗样式
.change-record-container {
  max-height: 500px;
  overflow-y: auto;

  .change-record-card {
    margin-bottom: 15px;

    .record-header {
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      .record-label {
        font-weight: 600;
        color: #606266;
      }

      .record-value {
        color: #303133;
        margin-right: 10px;
      }

      .record-divider {
        margin: 0 10px;
        color: #909399;
      }
    }

    .record-content {
      .record-title {
        font-weight: 600;
        color: #606266;
        margin-bottom: 10px;
      }

      .record-item {
        padding: 5px 0;
        color: #303133;
        line-height: 1.6;
      }
    }
  }
}
</style>
